import { render } from "./Wecome.vue?vue&type=template&id=a50fab54&scoped=true"
import script from "./Wecome.vue?vue&type=script&lang=js"
export * from "./Wecome.vue?vue&type=script&lang=js"

import "./Wecome.vue?vue&type=style&index=0&id=a50fab54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a50fab54"

export default script